export const INCREMENT = 'INCREMENT';
export const DECREMENT = 'DECREMENT';
export const RESET = 'RESET';
export const NEW_PREVIEW = 'NEW_PREVIEW';
export const FINISH_PREVIEW = 'FINISH_PREVIEW';
export const RESET_TILECOUNT = 'RESET_TILECOUNT';
export const INCREMENT_TILECOUNT = 'INCREMENT_TILECOUNT';
export const RESET_HEADERCOUNT = 'RESET_HEADERCOUNT';
export const INCREMENT_HEADERCOUNT = 'INCREMENT_HEADERCOUNT';
export const SET_HEADER_URL = 'SET_HEADER_URL';
export const SET_HEADER_FILE = 'SET_HEADER_FILE';
export const RESET_HEADER = "RESET_HEADER";
export const TILE_IMAGE_UPLOADED = 'TILE_IMAGE_UPLOADED';
export const TILE_IMAGES_RESET = 'TILE_IMAGES_RESET';
export const TILE_IMAGE_DELETED = 'TILE_IMAGE_DELETED';
export const SET_EMAIL = 'SET_EMAIL';
